import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { ElLoading } from 'element-plus';
import { showErrorMessage } from '@/utils/index';
import QRCode from 'qrcode';
// import logos from '@/assets/logo.png'
import { config, acceptImageFormats } from '../config';
// import { longWebURL } from '@/api/index';

export default {
  name: 'Url',
  data() {
    return {
      clearTrueFalse: false,
      acceptImageFormats,
      baseUrl: config.baseUrl,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      logoSizeBg: 0.25,
      logoSizeBgBlur: 3,
      logoPosition: "M",
      form: {
        width: 200,
        rongcuoA: 'H',
        errorCorrectionLevel: "H",
        // 可选，容错级别，值有 L（低）、M（中）、Q（高）、H（最高），默认为H
        type: "image/jpeg",
        // 可选，生成的二维码类型
        quality: 100,
        // 可选，二维码质量
        margin: 5,
        // 可选，二维码留白边距1
        color: {
          dark: "#000000",
          // 可选，前景色，格式必须是十六进制的，如果不是则会报错，比如：blue或rgb(255,245,255)等
          light: "#ffffff" // 可选，背景色，格式同上
        }
        // version: args.qversion,
        // small: !!args.small,
        // inverse: !!args.inverse,
        // maskPattern: args.mask,
        // scale: args.scale,
      },
      drawer: false,
      placeholder: '请输入文字或链接，来生成二维码，设置二维码区域可以设计二维码颜色 、宽度、质量、容错率',
      text: '',
      tabPosition: 'top',
      fileList: [],
      imageSrc: '',
      loading: false,
      disabledBtn: false,
      showImg: false,
      radioA: '1',
      options: {
        quality: 100,
        format: '',
        divide: 1,
        cdn: false,
        cdnDir: ''
      },
      omitBackground: false,
      downloadTxt: '下载二维码',
      btnGet: '生成二维码'
    };
  },
  mounted() {
    this.radioA = '1';
  },
  computed: {
    uploadOptions() {
      const {
        quality,
        format,
        cdn,
        cdnDir
      } = this.options;
      return {
        quality: quality,
        format: format,
        cdn: cdn || '',
        cdnDir
      };
    }
  },
  watch: {
    radioA(newv) {
      if (newv === '1') {
        this.downloadTxt = '下载网页长图图片', this.btnGet = '获取网页长图图片';
      } else {
        this.downloadTxt = '下载PDF网页', this.btnGet = '获取PDF网页';
      }
    },
    fileList: {
      handler(newVal) {
        console.log(newVal);
        if (!this.clearTrueFalse) {
          if (this.text && this.text.length > 0) {
            this.createLogo(this.logoSizeBg);
          }
        }
      },
      deep: true // 开启深度监听
    },
    form: {
      handler(newVal) {
        console.log(newVal);
        if (!this.clearTrueFalse) {
          this.createLogo(this.logoSizeBg);
        }
      },
      deep: true // 开启深度监听
    },
    logoSizeBg(newv) {
      // console.log(newv)
      if (!this.clearTrueFalse) {
        this.createLogo(newv);
      }
    },
    logoSizeBgBlur(news) {
      console.log(news);
      if (!this.clearTrueFalse) {
        this.createLogo(this.logoSizeBg);
      }
    },
    logoPosition(news) {
      console.log(news);
      if (!this.clearTrueFalse) {
        this.createLogo(this.logoSizeBg);
      }
    }
  },
  methods: {
    onSuccess(response) {
      // console.log(response, file, fileLists, '文件上传成功回调---')
      if (response && response.data) {
        this.fileList = [{
          response: response
        }];
      }
    },
    onChange(file) {
      this.fileList = [file];
    },
    handleDownload(file) {
      console.log(file);
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    setLogoRCFn(e) {
      this.logoPosition = e;
    },
    setRCFn(e) {
      this.form.errorCorrectionLevel = e;
    },
    onSubmit() {
      console.log('submit!');
    },
    setCode() {
      this.drawer = true;
    },
    clearFn() {
      this.clearTrueFalse = true;
      this.text = '';
      this.imageSrc = '';
      this.loading = false;
      this.disabledBtn = false;
      this.showImg = false;
      this.fileList = [];
      this.form = {
        width: 200,
        rongcuoA: 'H',
        errorCorrectionLevel: "H",
        // 可选，容错级别，值有 L（低）、M（中）、Q（高）、H（最高），默认为H
        type: "image/jpeg",
        // 可选，生成的二维码类型
        quality: 100,
        // 可选，二维码质量
        margin: 5,
        // 可选，二维码留白边距1
        color: {
          dark: "#000000",
          // 可选，前景色，格式必须是十六进制的，如果不是则会报错，比如：blue或rgb(255,245,255)等
          light: "#ffffff" // 可选，背景色，格式同上
        }
        // version: args.qversion,
        // small: !!args.small,
        // inverse: !!args.inverse,
        // maskPattern: args.mask,
        // scale: args.scale,
      };
      this.logoSizeBg = 0.25;
      setTimeout(() => {
        this.clearTrueFalse = false;
      }, 1000);
    },
    onInputBlur() {
      if (!this.text) {
        showErrorMessage('二维码内容不能为空！');
        return;
      }

      // if (!this.text.startsWith('http')) {
      //   showErrorMessage('请输入有效的链接地址');
      //   return;
      // }
      this.disabledBtn = true;
      const loadingss = ElLoading.service({
        lock: true,
        text: '二维码生成中。。。',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // const time = Date.now();
      const inputText = this.text;
      if (inputText.length) {
        this.createLogo(0.25);
        loadingss.close();
        this.drawer = false;
      } else {
        showErrorMessage('请输入有效的链接');
        loadingss.close();
      }
      // this.text = '';
      this.disabledBtn = false;
    },
    async createLogo(logoSizeBg) {
      console.log(this.fileList, logoSizeBg, '---');
      if (!this.text) {
        // 假设 showErrorMessage 是一个全局函数或者组件方法
        showErrorMessage('二维码内容不能为空！');
        return;
      }
      if (this.fileList && this.fileList.length > 0) {
        const fileItem = this.fileList[0];
        console.log(fileItem, '===');
        if (fileItem.raw && fileItem.raw.type) {
          const qrCodeCanvas = document.createElement('canvas');
          const ctx = qrCodeCanvas.getContext('2d');
          qrCodeCanvas.width = this.form.width;
          qrCodeCanvas.height = this.form.width;
          await QRCode.toCanvas(qrCodeCanvas, this.text, this.form);
          const logo = new Image();
          logo.src = URL.createObjectURL(fileItem.raw);
          console.log(logo.src, '---');
          logo.onload = () => {
            // 设置阴影效果
            ctx.shadowOffsetX = this.logoSizeBgBlur; // 阴影水平偏移
            ctx.shadowOffsetY = this.logoSizeBgBlur; // 阴影垂直偏移
            ctx.shadowBlur = this.logoSizeBgBlur; // 阴影模糊程度
            ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'; // 阴影颜色

            const logoSize = qrCodeCanvas.width * logoSizeBg;
            const logoWidth = logo.width;
            const logoHeight = logo.height;
            const h = logoSize * logoHeight / logoWidth;
            let logoX = (qrCodeCanvas.width - logoSize) / 2;
            let logoY = (qrCodeCanvas.width - h) / 2;
            if (this.logoPosition === 'RB') {
              logoX = qrCodeCanvas.width - logoSize - this.form.margin;
              logoY = qrCodeCanvas.width - h - this.form.margin;
            }
            ctx.drawImage(logo, logoX, logoY, logoSize, h);

            // 清除阴影设置（如果需要的话，以便后续的绘制不受影响）
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            ctx.shadowBlur = 0;
            ctx.shadowColor = 'rgba(0, 0, 0, 0)';
            this.imageSrc = qrCodeCanvas.toDataURL('image/png');
            setTimeout(() => {
              this.loading = false;
              this.showImg = true;
              URL.revokeObjectURL(logo.src);
            }, 600);
          };
          logo.onerror = () => {
            console.error('Logo 加载失败');
            this.loading = false;
          };
        } else {
          console.error('文件响应数据不完整');
          this.loading = false;
        }
      } else {
        this.createQrCode(this.text, this.form).then(url => {
          this.imageSrc = url;
          setTimeout(() => {
            this.loading = false;
            this.showImg = true;
          }, 600);
        }).catch(error => {
          this.loading = false;
          console.error('Error generating QR Code:', error);
        });
      }
    },
    createQrCode(text, options) {
      return new Promise((resolve, reject) => {
        QRCode.toDataURL(text, options, (err, url) => {
          if (err) {
            reject(err);
          } else {
            resolve(url);
          }
        });
      });
    },
    downloadPdf(url) {
      // 创建一个临时的a标签
      var a = document.createElement("a");
      // 隐藏a标签，避免在页面中显示
      a.style.display = "none";
      // 设置a标签的href属性为PDF的URL
      a.href = url;
      // 设置下载的文件名（可选，如果不设置，浏览器会尝试使用URL的最后一部分作为文件名）
      // 注意：某些浏览器可能不支持此操作，或者需要服务器配置支持Content-Disposition
      a.download = "压图.pdf"; // 替换为你希望的文件名
      // 将a标签添加到文档中
      document.body.appendChild(a);
      // 模拟点击a标签
      a.click();
      // 移除a标签
      document.body.removeChild(a);
    },
    pdfDownload(fileName, response) {
      let blob = new Blob([response], {
        type: "application/pdf"
      });
      var downloadElement = document.createElement("a");
      var href = window.URL.createObjectURL(blob);
      downloadElement.href = href;
      downloadElement.download = fileName;
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
      window.URL.revokeObjectURL(href);
    },
    downloadBase64Image(base64String, filename) {
      // 如果base64String是DataURL（如data:image/png;base64,iVBORw0K...），则直接使用
      // 如果只是纯Base64编码，则需要先加上'data:image/png;base64,'（这里以PNG为例，根据实际情况修改）
      // 注意：这里的MIME类型（这里是image/png）应该与你的Base64编码的图像类型相匹配
      let imageUrl = base64String;
      if (!base64String.startsWith('data:image/')) {
        // 假设是PNG图片
        imageUrl = 'data:image/png;base64,' + base64String;
      }

      // 创建一个临时的a标签
      let link = document.createElement('a');
      link.href = imageUrl;
      link.download = filename; // 设置下载的文件名
      // 触发点击
      document.body.appendChild(link); // 需要添加到文档中
      link.click();

      // 清理：移除临时的a标签
      document.body.removeChild(link);
    },
    downloadAll() {
      this.clearTrueFalse = true;
      // 示例使用
      let base64ImageString = this.imageSrc; // 假设这是你的Base64编码的图片数据
      const time = Date.now();
      let filename = `downloaded_image_${time}.png`; // 你想保存的文件名
      if (this.radioA === '2') {
        filename = `downloaded_image_${time}.pdf`;
        this.downloadPdf(this.imageSrc);
      } else {
        this.downloadBase64Image(base64ImageString, filename);
      }

      // this.text = ''
      this.drawer = false;
      this.fileList = [];
      setTimeout(() => {
        this.clearTrueFalse = false;
      }, 1000);
    },
    clearFileList() {
      this.fileList = [];
    }
  }
};